import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-roboto flex flex-col min-h-screen" }
const _hoisted_2 = { class: "max-w-7xl w-full mx-auto flex-1" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-x-8 gap-y-8 pt-10 pb-10 md:grid-cols-3" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"px-4\"><h2 class=\"text-2xl font-semibold leading-7 text-dark-blue\">Contact Us</h2><div class=\"flex items-start mt-6\"><img src=\"/img/Icons/home_contact_us.svg\" alt=\"\"><p class=\"ml-3 text-dark-blue\"> GetGo Fund NPC <br> 9 Ntemi Piliso street, <br> Ferreiras Dorp, <br> Johannesburg, <br> 2107 </p></div><div class=\"flex items-center mt-3\"><img src=\"/img/Icons/phone_contact_us.svg\" alt=\"\"><p class=\"ml-3 text-dark-blue\">+27 (0)21 007 5786</p></div><div class=\"flex items-center mt-3\"><img src=\"/img/Icons/email_contact_us.svg\" alt=\"\"><a class=\"ml-3 text-dark-blue\" href=\"mailto:support@getgofund.org\">support@getgofund.org</a></div></div>", 1)
const _hoisted_5 = { class: "bg-white shadow-md ring-1 ring-gray-900/5 rounded-xl md:col-span-2 mx-3" }
const _hoisted_6 = { class: "px-4 py-6 sm:p-8" }
const _hoisted_7 = { class: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mx-auto" }
const _hoisted_8 = { class: "sm:col-span-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "First Name*", -1)
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_12 = { class: "sm:col-span-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Last Name*", -1)
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_16 = { class: "sm:col-span-full sm:col-start-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Email*", -1)
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_20 = {
  key: 1,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_21 = { class: "sm:col-span-full sm:col-start-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Phone Number*", -1)
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = {
  key: 0,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_25 = {
  key: 1,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_26 = { class: "col-span-full" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium leading-6 text-dark-blue" }, "Message*", -1)
const _hoisted_28 = { class: "mt-2" }
const _hoisted_29 = {
  key: 0,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_30 = {
  key: 1,
  class: "text-red-500 text-xs mt-1.5"
}
const _hoisted_31 = { class: "col-span-full sm:w-96 sm:mx-auto mt-0 sm:mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Sidebar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.firstName) = $event)),
                      type: "text",
                      placeholder: "First Name",
                      class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                    }, null, 512), [
                      [_vModelText, $setup.firstName]
                    ]),
                    ($setup.firstNameError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Please enter your first name"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.lastName) = $event)),
                      type: "text",
                      placeholder: "Last Name",
                      class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                    }, null, 512), [
                      [_vModelText, $setup.lastName]
                    ]),
                    ($setup.lastNameError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Please enter your last name"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.email) = $event)),
                      type: "text",
                      placeholder: "Email",
                      class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                    }, null, 512), [
                      [_vModelText, $setup.email]
                    ]),
                    ($setup.emailError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Please enter email"))
                      : _createCommentVNode("", true),
                    ($setup.invalidEmailError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Please fill in a valid Email"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.phoneNumber) = $event)),
                      type: "text",
                      placeholder: "Phone Number",
                      class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
                    }, null, 512), [
                      [_vModelText, $setup.phoneNumber]
                    ]),
                    ($setup.phoneNumberError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Please enter a phone number"))
                      : _createCommentVNode("", true),
                    ($setup.invalidPhoneNumberError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Please fill in a valid South African phone number"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("textarea", {
                      required: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.message) = $event)),
                      rows: "4",
                      class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6 outline-none"
                    }, null, 512), [
                      [_vModelText, $setup.message]
                    ]),
                    ($setup.messageError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Please enter a message"))
                      : _createCommentVNode("", true),
                    ($setup.messageLengthError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Message must be between 10 and 250 characters"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Button, {
                    onClick: $setup.handleSendMessage,
                    buttonText: "Send Message",
                    class: "bg-dark-blue text-white w-full py-2.5 shadow-lg"
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Footer)
    ])
  ], 64))
}